import * as React from 'react';
import { EntityMapMarker } from '../entities/entity-map-marker';
export var defaultEntityMapMarkersSet = {
  Entity: EntityMapMarker
};
export var EntityTypeMapMarkersContext = React.createContext(defaultEntityMapMarkersSet);
export var EntityTypeMapMarkersProvider = EntityTypeMapMarkersContext.Provider;